module.exports = __webpack_public_path__ + "static/media/auranest-logo.0f618f86.svg";